document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initContadores();
  initMarquesina();
});

function initReveals() {
  var els = document.querySelectorAll('.pv-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('pv-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('pv-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initContadores() {
  var els = document.querySelectorAll('[data-pv-contador]');
  if (!els.length) return;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        obs.unobserve(el);
        var fin = parseFloat(el.getAttribute('data-pv-contador')) || 0;
        var sufijo = el.getAttribute('data-pv-sufijo') || '';
        if (reduceMotion) {
          el.textContent = fin + sufijo;
          return;
        }
        var inicio = 0;
        var duracion = 1400;
        var t0 = null;
        function paso(ts) {
          if (!t0) t0 = ts;
          var progreso = Math.min((ts - t0) / duracion, 1);
          var actual = Math.floor(inicio + (fin - inicio) * (1 - Math.pow(1 - progreso, 3)));
          el.textContent = actual + sufijo;
          if (progreso < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initMarquesina() {
  var tracks = document.querySelectorAll('[data-pv-marquesina-track]');
  tracks.forEach(function (track) {
    if (track.dataset.pvDuplicado) return;
    track.dataset.pvDuplicado = '1';
    var clone = track.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.parentNode.appendChild(clone);
  });
}
